import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UseUnpublishCampaignProps = Readonly<{
  campaignId: string | undefined
  onUnpublished: () => void
  onError: (error: Record<'code' | 'message' | 'title', string>) => void
}>

export type UseUnpublishCampaignReturn = Readonly<{
  isLoading: boolean
  unpublishCampaign: () => void
}>

const defaultError = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useUnpublishCampaign = ({
  campaignId,
  onUnpublished,
  onError
}: UseUnpublishCampaignProps): UseUnpublishCampaignReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: unpublishCampaign }] = useMutation(
    workplaceGivingService.unpublishGivingCampaign,
    () => {
      onUnpublished()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    unpublishCampaign: () => {
      if (campaignId) {
        unpublishCampaign(campaignId)
      }
    }
  }
}
